// 💾 src/pages/client/sections/components/Profile/Security.tsx
import { useState } from "react"
import "./style/Security.scss"

const Security = () => {
  const [emailVerified, setEmailVerified] = useState(true)
  const [mobileVerified, setMobileVerified] = useState(false)
  const [gaEnabled, setGaEnabled] = useState(true)

  const [antiPhishingCode, setAntiPhishingCode] = useState("123021")

  const [fastWithdraw, setFastWithdraw] = useState(false)
  const [whitelistEnabled, setWhitelistEnabled] = useState(false)
  const [dexTransfer, setDexTransfer] = useState(false)

  return (
    <div className="security-settings">
      <h2>Security</h2>

      <div className="security-card">
        <h3>Two-Factor Authentication (2FA)</h3>
        <p>To protect your account, we recommend enabling at least one 2FA option.</p>
        <ul>
          <li>
            <div className="label">Email Verification</div>
            <div className="value">{emailVerified ? "✅ example@email.com" : "❌ Not verified"}</div>
            <button>Change</button>
          </li>
          <li>
            <div className="label">Mobile Verification</div>
            <div className="value">{mobileVerified ? "✅ +12345678" : "❌ Not verified"}</div>
            <button>Change</button>
          </li>
          <li>
            <div className="label">Google Authenticator Code</div>
            <div className="value">{gaEnabled ? "On" : "Off"}</div>
            <button>{gaEnabled ? "Remove" : "Enable"}</button>
          </li>
        </ul>
      </div>

      <div className="security-card">
        <h3>Advanced Security</h3>
        <ul>
          <li>
            <div className="label">Anti-Phishing Code</div>
            <div className="value">{antiPhishingCode}</div>
            <button>Change</button>
          </li>
          <li>
            <div className="label">Login Password</div>
            <div className="value">*********</div>
            <button>Change</button>
          </li>
        </ul>
      </div>

      <div className="security-card">
        <h3>End Security Settings</h3>
        <ul>
          <li>
            <div className="label">Fast Withdrawal</div>
            <div className="value">{fastWithdraw ? "Enabled" : "Disabled"}</div>
            <label className="switch">
              <input type="checkbox" checked={fastWithdraw} onChange={() => setFastWithdraw(!fastWithdraw)} />
              <span className="slider"></span>
            </label>
          </li>
          <li>
            <div className="label">Withdrawal Whitelist</div>
            <div className="value">{whitelistEnabled ? "Enabled" : "Disabled"}</div>
            <label className="switch">
              <input type="checkbox" checked={whitelistEnabled} onChange={() => setWhitelistEnabled(!whitelistEnabled)} />
              <span className="slider"></span>
            </label>
          </li>
          <li>
            <div className="label">DEX - Quick Transfer</div>
            <div className="value">{dexTransfer ? "Enabled" : "Disabled"}</div>
            <label className="switch">
              <input type="checkbox" checked={dexTransfer} onChange={() => setDexTransfer(!dexTransfer)} />
              <span className="slider"></span>
            </label>
          </li>
        </ul>
      </div>

      <div className="security-card">
        <h3>Third-Party Account Authorization</h3>
        <div className="third-party-links">
          <button className="linked">Google</button>
          <button>Apple</button>
          <button>MetaMask</button>
          <button>Telegram</button>
        </div>
      </div>

      <div className="security-card">
        <h3>Devices and Activities</h3>
        <ul>
          <li>
            <div className="label">Account Activities</div>
            <button>View</button>
          </li>
          <li>
            <div className="label">Device Management</div>
            <button>Manage</button>
          </li>
          <li>
            <div className="label">Freeze Account</div>
            <button className="danger">Freeze</button>
          </li>
        </ul>
      </div>

      <div className="security-card">
        <h3>Other</h3>
        <ul>
          <li>
            <div className="label">MEXC Verify</div>
            <div className="value">External identity verification (Telegram, WeChat etc.)</div>
            <button>Verify</button>
          </li>
        </ul>
      </div>
    </div>
  )
}

export default Security
